module.exports = __webpack_public_path__ + "static/media/70percent.67b97afd.png";